import clsx from 'clsx';
import styles from './TextField.module.css';

export function TextField({
  className = '',
  inputClassName = '',
  id,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  readOnly = false,
  right = null,
  ariaLabel,
  name,
  type = 'text',
  variant = 'default',
  invalid = false,
  maxLength,
  variableTarget = false,
}) {
  const isEmptyValue = String(value ?? '').trim().length === 0;
  return (
    <div
      className={clsx(
        styles.field,
        variant === 'form' && styles.fieldForm,
        variant === 'form' && isEmptyValue && styles.fieldFormEmpty,
        invalid && styles.fieldInvalid,
        className,
      )}
      data-disabled={disabled ? 'true' : 'false'}
    >
      <input
        id={id}
        className={clsx(inputClassName)}
        aria-label={ariaLabel}
        aria-invalid={invalid ? 'true' : undefined}
        disabled={disabled}
        readOnly={readOnly}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(e) => onChange?.(e.target.value, e)}
        onBlur={onBlur}
        data-variable-target={variableTarget ? 'true' : undefined}
      />
      {right ? <div className={styles.right}>{right}</div> : null}
    </div>
  );
}
